import { render, staticRenderFns } from "./RegisterView.vue?vue&type=template&id=728824b3&scoped=true"
import script from "./RegisterView.vue?vue&type=script&lang=js"
export * from "./RegisterView.vue?vue&type=script&lang=js"
import style0 from "./RegisterView.vue?vue&type=style&index=0&id=728824b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728824b3",
  null
  
)

export default component.exports